import L from 'leaflet';

import { MAP_TILES, tileOptions } from '../ui/mapTiles.js';

export function initializeLeafletMap(mapElement) {
    try {
        const map = L.map(mapElement, { preferCanvas: true }).setView([20, 0], 3);

        // Couches satellite (par défaut) : imagerie Esri + labels transparents par-dessus
        const satelliteLayer = L.tileLayer(MAP_TILES.satellite.url, tileOptions('satellite'));
        const satelliteLabels = L.tileLayer(MAP_TILES.satelliteLabels.url, tileOptions('satelliteLabels', { pane: 'shadowPane' }));
        // Couche plan (basculée via addMapTypeControl / toggleMapType)
        const streetLayer = L.tileLayer(MAP_TILES.plan.url, tileOptions('plan'));

        satelliteLayer.addTo(map);
        satelliteLabels.addTo(map);

        // Conservées sur l'instance pour permettre le basculement plan/satellite
        map.__monalerteBaseLayers = { satelliteLayer, satelliteLabels, streetLayer };

        return map;
    } catch (e) {
        console.error("Erreur Leaflet init:", e);
        return null;
    }
}

/** Bascule entre la couche satellite (défaut) et la couche plan standard. */
export function toggleMapType(map, showSatellite) {
    const layers = map && map.__monalerteBaseLayers;
    if (!layers) return;
    if (showSatellite) {
        map.removeLayer(layers.streetLayer);
        layers.satelliteLayer.addTo(map);
        layers.satelliteLabels.addTo(map);
    } else {
        map.removeLayer(layers.satelliteLayer);
        map.removeLayer(layers.satelliteLabels);
        layers.streetLayer.addTo(map);
    }
}

/** Bouton flottant (haut gauche) pour basculer satellite/plan (Design Material 48px). */
export function addMapTypeControl(map, onToggle) {
    let showingSatellite = true;
    const typeBtn = L.control({ position: 'topleft' });
    typeBtn.onAdd = function () {
        const div = L.DomUtil.create('div', 'leaflet-control custom-map-circle-btn');
        // Icône Satellite / Plan
        const mapSvg = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#00BCD4"><path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"/></svg>`;
        const satSvg = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#00BCD4"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V7h2v10zm4-4h-2V7h2v6zm-8 4H8V7h2v10z"/></svg>`;
        
        div.innerHTML = mapSvg;
        div.title = "Changer le type de carte (Plan / Satellite)";

        div.onclick = (e) => {
            L.DomEvent.stopPropagation(e);
            showingSatellite = !showingSatellite;
            div.innerHTML = showingSatellite ? mapSvg : satSvg;
            onToggle(showingSatellite);
        };
        return div;
    };
    typeBtn.addTo(map);
}

/** Bouton flottant (haut gauche) pour recentrer la carte (Design Material 48px). */
export function addRecenterControl(map, onRecenter) {
    const recenterBtn = L.control({ position: 'topleft' });
    recenterBtn.onAdd = function () {
        const div = L.DomUtil.create('div', 'leaflet-control custom-map-circle-btn');
        // Icône MyLocation (Aligné sur Android RecenterUserButton)
        const myLocationSvg = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#00BCD4"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>`;
        
        div.innerHTML = myLocationSvg;
        div.title = "Recentrer sur la position";
        
        div.onclick = (e) => {
            L.DomEvent.stopPropagation(e);
            onRecenter();
        };
        return div;
    };
    recenterBtn.addTo(map);
}